var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashnaIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashna"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1736",
    width: 40,
    height: 40,
    rx: 8,
    fill: "#5F60FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dashna Symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.769 11.9583V31.8349C25.5522 30.2182 27.4536 27.1274 27.4536 23.759V7.27271C24.8662 7.27271 22.769 9.36982 22.769 11.9573V11.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1089 18.4694V32.4212C16.9028 32.6329 17.7386 32.7418 18.6035 32.7258C19.4233 32.7118 20.2132 32.569 20.9682 32.3333V13.5781V13.5831C18.2849 13.5831 16.1089 15.7861 16.1089 18.4694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 23.9678C10 27.1724 11.7316 29.9655 14.3061 31.4825V16.4531C11.7326 17.971 10 20.7642 10 23.9678Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashnaIco);
export default __webpack_public_path__ + "static/media/dashnaIco.6bbc5b0660286de5459d7691f8434ae1.svg";
export { ForwardRef as ReactComponent };